
import { int } from "@goodgamestudios/math-utilities";

import { getLogger } from "@goodgamestudios/logger";

import { GetXPAnimationVO } from "./animationvo/GetXPAnimationVO";
import { GetXPAniHelper } from "./GetXPAniHelper";
import { IAniHelper } from "./IAniHelper";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;

const logger = getLogger("GetXPAniHelperController");

export class GetXPAniHelperController {
    private _getXPAnimations: GetXPAniHelper[];
    private _getXPAnimationsArr: any[] = [];
    private _xpAniIdCounter: number = 0;
    private _xpAniId: string;

    constructor() {
        this._getXPAnimations = [];
    }

    public get xpAniId(): string {
        this._xpAniIdCounter++;
        this._xpAniId = "xpAni_" + this._xpAniIdCounter.toString();
        return this._xpAniId;
    }

    public set xpAniId(value: string) {
        this._xpAniId = value;
    }

    public showXPAnimation(gainedXP: string, playerContainer: MovieClip, menuPanel: DisplayObject, animationContainer: Container, tableScreen: DisplayObject): void {
        // configure animation vo
        var vo: GetXPAnimationVO = new GetXPAnimationVO(gainedXP, playerContainer, menuPanel, animationContainer);
        vo.animationCompleteCallback = this.bindFunction(this.onAnimationComplete);

        // create animation helper
        var animation: IAniHelper = new GetXPAniHelper(tableScreen.scaleX);

        // store animation
        this._getXPAnimations.push(animation as GetXPAniHelper);

        // execute animation
        animation.doAnimation(vo);
    }

    private onAnimationComplete(finishedAni: IAniHelper): void {
        var i: number = 0;
        var len: number = int(this._getXPAnimations.length);
        var tempAni: GetXPAniHelper;

        for (i = 0; i < len; ++i) {
            try {
                tempAni = this._getXPAnimations[i];
            }
            catch (error) { // RangeError
                logger.error("onAnimationComplete() -> RANGE ERROR, i: " + this._getXPAnimations, this._getXPAnimations.length);
                return;
            }

            if (tempAni == finishedAni) {
                finishedAni.kill();
                finishedAni = null;
                this._getXPAnimations.splice(i, 1);
                break;
            }
        }
    }

    public kill(): void {
        var i: number = 0;
        var len: number = int(this._getXPAnimations.length);
        var tempAni: GetXPAniHelper;
        for (i = 0; i < len; ++i) {
            tempAni = this._getXPAnimations[i];
            tempAni.kill();
            tempAni = null;
        }

        // re-initialize
        this._getXPAnimations = [];
    }
}
